module.exports = __webpack_public_path__ + "img/story-mode-il.f1561e56.svg";